import React from 'react';
import * as styles from './GroupViewControls.module.scss';
import { ButtonWithLoadingState } from '../components/Button';
import { MenuItem, MenuSeparator } from '../components/Menu';
import OverflowMenu from '../components/OverflowMenu';
import Tooltip from '../components/Tooltip';
import editIcon from '../icons/non-prefilled/16x16/editPost.svg';
import memberIcon from '../icons/non-prefilled/16x16/member.svg';
import memberRemoveIcon from '../icons/non-prefilled/16x16/memberRemove.svg';
import topicIcon from '../icons/non-prefilled/16x16/topic.svg';
import trashIcon from '../icons/non-prefilled/16x16/trash.svg';
import AdminBadge from '../user/AdminBadge';

interface GroupViewControlsProps {
  onEdit?: () => void;
  onJoin?: () => Promise<void>;
  onLeave?: () => Promise<void>;
  onRequest?: () => Promise<void>;
  onDelete?: (() => Promise<unknown>) | null;
  onViewTopicMemberships?: () => void;
  requested: boolean;
  isRequesting: boolean;
}

const getDisabledProps = (check: boolean) =>
  check
    ? {}
    : {
        disabled: true,
        tooltip: 'Only group owners can edit this group',
      };

const GroupViewControls = ({
  onEdit,
  onJoin,
  onLeave,
  onRequest,
  onDelete,
  onViewTopicMemberships,
  requested,
  isRequesting,
}: GroupViewControlsProps) => {
  return (
    <div className={styles.controls}>
      <OverflowMenu applyNegativeMargin={false}>
        {onViewTopicMemberships && (
          <MenuItem icon={topicIcon} onClick={() => onViewTopicMemberships()}>
            View topic membership
          </MenuItem>
        )}
        <MenuSeparator />
        <MenuItem
          icon={editIcon}
          onClick={() => onEdit?.()}
          {...getDisabledProps(!!onEdit)}
        >
          Edit appearance
        </MenuItem>
        {onLeave && (
          <MenuItem icon={memberRemoveIcon} onClick={() => onLeave()}>
            Leave group
          </MenuItem>
        )}
        {onDelete && (
          <>
            <MenuSeparator />
            <MenuItem icon={trashIcon} danger onClick={() => onDelete()}>
              Delete group
            </MenuItem>
          </>
        )}
        {onJoin && (
          <MenuItem
            icon={memberIcon}
            onClick={() => onJoin()}
            right={<AdminBadge />}
          >
            Join group
          </MenuItem>
        )}
      </OverflowMenu>
      {!onLeave && (
        <div className={styles.membershipButton}>
          {(onRequest || requested) && (
            <Tooltip
              content={
                requested
                  ? "Your request is still pending.\nYou will receive an email\nafter you've been accepted."
                  : undefined
              }
            >
              <ButtonWithLoadingState
                disabled={!onRequest}
                variant="primary"
                onClick={() => onRequest?.()}
                loading={isRequesting}
              >
                Request membership
              </ButtonWithLoadingState>
            </Tooltip>
          )}
        </div>
      )}
    </div>
  );
};

export default GroupViewControls;
